'use strict';
/**
 *  Module  
 *
 * Description
 */
angular.module('rankLineModule', []).directive('rankLine', ['$timeout', 'rankingList', function($timeout, rankingList) {
    return {
        restrict: 'E',
        replace: true,
        template: '<div ng-style="myStyle" class="absolute bd white rankLineChart"></div>',
        scope: {
            optionObj: "=",
            isTool: "=",
            myStyle: '=',
        },
        link: function(scope, iElement, iAttrs) {
            // scope.myStyle = { height: '<5></5>0px', width: '100px' };
            var option = rankingList.initOption();
            angular.forEach(option.series, function(value, key) {
                value.type = "line";
            });
            console.log('echarts');
            function formatDate(date){
                var tempDate = [];
                for (var i = 0; i < date.length; i++) {
                    var item = date[i].replace(' ', '\n');;
                    tempDate.push(item);
                };
                return tempDate;
            }
            $timeout(function() {
                require(['./lib/echarts/dist/echarts.min.js'], function(echarts) {
                    option.title.text = scope.optionObj.TITLE;
                    option.series[0].data = !scope.optionObj.SEARCH_INDEX_HISTORY ? [] : scope.optionObj.SEARCH_INDEX_HISTORY.split('|');
                    option.xAxis[0].data = !scope.optionObj.SEARCH_INDEX_DATES ? [] : formatDate(scope.optionObj.SEARCH_INDEX_DATES.split('|'));
                    option.xAxis[0].show = scope.isTool;
                    option.yAxis[0].show = scope.isTool;
                    option.series[0].show = scope.isTool;
                    var myChart = echarts.init(iElement[0], 'infographic');
                    myChart.setOption(option);
                });

            });
        }
    };
}]);
